export const COLONIAL_OPERATOR_ID = 290;
export const OPERATOR_LOYALTY_PROGRAM = 'operator_loyalty_program';
